import React from "react";
import PropTypes from "prop-types";

// custom
import FormResetPassword from "components/FormResetPassword";
import FormPersonalInfo from "components/FormPersonalInfo";

// material-ui
import Typography from "@material-ui/core/Typography";
import withStyles from "@material-ui/core/styles/withStyles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Chip from "@material-ui/core/Chip";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Avatar from "@material-ui/core/Avatar";
import Portal from "@material-ui/core/Portal";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";

// custom
import App from "components/App";
import Page from "components/Page";
import OrganizationsList from "components/OrganizationsList";
import FormOrganization from "components/FormOrganization";
import OrganizationDetail from "components/OrganizationDetail";

// styles
import styles from "./styles";

class WrapperMyAccountPage extends React.Component {
  static propTypes = {
    classes: PropTypes.object,
    urlParams: PropTypes.object,
    history: PropTypes.object,
    user: PropTypes.object,
    updateUser: PropTypes.func,
    refresh: PropTypes.func,
    updateUserPassword: PropTypes.func,

    organizations: PropTypes.array,
    createOrganization: PropTypes.func,
    deleteOrganization: PropTypes.func,
    updateOrganization: PropTypes.func,
    getOrganizationUsers: PropTypes.func,
    deleteOrganizationUser: PropTypes.func,
    addUserToOrganization: PropTypes.func,
    joinOrganization: PropTypes.func,

    userApps: PropTypes.array,
  };

  static contextTypes = {
    MessageCenter: PropTypes.object,
  };

  constructor(...args) {
    super(...args);
    const { MessageCenter } = this.context;
    const { urlParams } = this.props;
    this.state = {
      index: urlParams.index ? Number(urlParams.index) : 0,
      formOrganizationOpen: false,
    };
    MessageCenter.close("right");
  }

  getStepContent() {
    const {
      updateUserPassword,
      updateUser,
      user,
      classes,
      refresh,
      userApps,
      createOrganization,
      deleteOrganization,
      updateOrganization,
      getOrganizationUsers,
      deleteOrganizationUser,
      addUserToOrganization,
      joinOrganization,
      organizations,
      history,
    } = this.props;

    const { index, formOrganizationOpen, selectedOrganization } = this.state;

    const { MessageCenter } = this.context;

    switch (index) {
      case 0:
        return (
          <Grid
            container
            spacing={2}
            style={{ maxWidth: 800, marginLeft: "auto", marginRight: "auto" }}
          >
            <Grid item xs={12}>
              <FormPersonalInfo
                refresh={refresh}
                user={user}
                updateUser={updateUser}
              />
            </Grid>
            <Grid item xs={12}>
              <FormResetPassword
                user={user}
                updateUserPassword={updateUserPassword}
              />
            </Grid>
          </Grid>
        );
      case 1:
        return (
          <div>
            <OrganizationsList
              user={user}
              joinOrganization={joinOrganization}
              refresh={refresh}
              selectedOrganization={this.state.selectedOrganization}
              organizations={organizations || []}
              onSelect={(so) => {
                this.setState({
                  selectedOrganization: so,
                });
                MessageCenter.open("right");
              }}
            />
            <FormOrganization
              open={formOrganizationOpen}
              close={() => {
                this.setState({
                  formOrganizationOpen: false,
                });
                setTimeout(
                  () =>
                    this.setState({
                      selectedOrganization: undefined,
                    }),
                  200
                );
              }}
              createOrganization={createOrganization}
              deleteOrganization={deleteOrganization}
              updateOrganization={updateOrganization}
              refresh={refresh}
            />
            <Portal container={MessageCenter.getPortalContainer("right")}>
              {selectedOrganization &&
              selectedOrganization.ownerID === user.id ? (
                <ClickAwayListener
                  onClickAway={() => console.log("onClickAway")}
                >
                  <OrganizationDetail
                    user={user}
                    organization={selectedOrganization}
                    deleteOrganizationUser={deleteOrganizationUser}
                    updateOrganization={updateOrganization}
                    deleteOrganization={deleteOrganization}
                    getOrganizationUsers={getOrganizationUsers}
                    addUserToOrganization={addUserToOrganization}
                    joinOrganization={joinOrganization}
                    refresh={refresh}
                    history={history}
                    close={() => {
                      this.setState({ selectedOrganization: undefined });
                      MessageCenter.close("right");
                    }}
                    refreshKey={
                      selectedOrganization ? selectedOrganization.id : undefined
                    }
                  />
                </ClickAwayListener>
              ) : (
                []
              )}
            </Portal>
          </div>
        );
      default:
        return (
          <Typography variant="h6">
            You have gone too far, Sonny Jim !
          </Typography>
        );
    }
  }

  render() {
    const { classes, history } = this.props;

    const { index } = this.state;

    return (
      <Page
        helmet="My Account"
        loadingMessage={"Loading Information"}
        tabs={
          <React.Fragment>
            <Tabs
              value={index}
              onChange={(e, v) => {
                this.setState({
                  index: v,
                });
                history.push(`?index=${v}`);
              }}
              indicatorColor="primary"
              textColor="primary"
              scrollButtons="auto"
              classes={{
                root: classes.tabsRoot,
                indicator: classes.tabsIndicator,
              }}
            >
              <Tab
                label="My Account"
                classes={{
                  root: classes.tabRoot,
                  selected: classes.tabSelected,
                }}
              />
            </Tabs>
          </React.Fragment>
        }
      >
        {this.getStepContent()}
      </Page>
    );
  }
}
export default withStyles(styles)(WrapperMyAccountPage);
